import { sendInfrastructureAnalytics } from '../utils';

export const trackInfrastructureCategoryModalOpen = (infrastructureType: string) => {
  sendInfrastructureAnalytics({
    action: 'expand_block',
    infrastructureType,
  });
};
